import React from "react";

// router
import { Switch, Route } from "react-router-dom";

// components
// auth
import Login from "components/Auth/Login";
import ForgotPassword from "components/Auth/ForgotPassword";
import ResetPassword from "components/Auth/ResetPassword";

import Dashboard from "components/Dashboard";

import Users from "components/Users";
import CreateUser from "components/Users/Pages/CreateUser";
import EditUser from "components/Users/Pages/EditUser";

import Emails from "components/Emails";
import CreateEmail from "components/Emails/Pages/CreateEmail";
import EditEmail from "components/Emails/Pages/EditEmail";

import Categories from "components/Categories";

import Brands from "components/Brands";
import CreateBrand from "components/Brands/Pages/CreateBrand";
import EditBrand from "components/Brands/Pages/EditBrand";

import Products from "components/Products";
import CreateProduct from "components/Products/Pages/CreateProduct/";
import EditProduct from "components/Products/Pages/EditProduct/";

import Coupons from "components/Coupons";
import CreateCoupon from "components/Coupons/Pages/CreateCoupon";
import EditCoupon from "components/Coupons/Pages/EditCoupon";

import Blogs from "components/Blogs";
import CreateBlog from "components/Blogs/Pages/CreateBlog";
import EditBlog from "components/Blogs/Pages/EditBlog";

import Customers from "components/Customers";
import CreateCustomer from "components/Customers/Pages/CreateCustomer";
import EditCustomer from "components/Customers/Pages/EditCustomer";

import CustomerGroups from "components/CustomerGroups";
import CreateCustomerGroup from "components/CustomerGroups/Pages/CreateCustomerGroup";
import EditCustomerGroup from "components/CustomerGroups/Pages/EditCustomerGroup";

import EditSaleOrder from "components/SaleOrders/Pages/EditSaleOrder";
import CreateSaleOrder from "components/SaleOrders/Pages/CreateSaleOrder";
import SaleOrders from "components/SaleOrders";

import Vendors from "components/Vendors";
import CreateVendor from "components/Vendors/Pages/CreateVendor";
import EditVendor from "components/Vendors/Pages/EditVendor";

import PurchaseOrders from "components/PurchaseOrders";
import EditPurchaseOrder from "components/PurchaseOrders/Pages/EditPurchaseOrder";

import Multipliers from "components/Multipliers";
import StoreMultiplier from "components/Multipliers/Pages/StoreMultiplier";
import CategoryMultiplier from "components/Multipliers/Pages/CategoryMultiplier";
import ProductMultiplier from "components/Multipliers/Pages/ProductMultiplier";
import BrandMultiplier from "components/Multipliers/Pages/BrandMultiplier";
import ShippingMultiplier from "components/Multipliers/Pages/ShippingMultiplier";

import Integration from "components/Integration";
import IntegrationDetails from "components/Integration/pages/IntegrationView/IntegrationDetails";
import Quickbooks from "components/Integration/pages/QuickBooks";
import QuickbooksConnect from "components/Integration/pages/QuickBooks/QuickbooksConnect";
// import Stores from "components/Integration/pages/QuickBooks/Store";
// import CreateStore from "components/Integration/pages/QuickBooks/Store/Pages/CreateStore";
// import CreateProducts from "components/Integration/pages/QuickBooks/Products/Pages/CreateProducts";
// import CreateCustomers from "components/Integration/pages/QuickBooks/Customers/Pages/CreateCustomers";
import QuickBooksSetting from "components/Integration/pages/QuickBooks/QuickBooksSetting";

import MailChimpConnect from "components/Integration/pages/Mailchimp/MailchimpConnect";
import MailChimp from "components/Integration/pages/Mailchimp";
import MailchimpSetting from "components/Integration/pages/Mailchimp/MailchimpSettings";

// abandoned carts
import AbandonedCart from "components/AbandonedCart";
import AbandonedCartDetails from "components/AbandonedCart/Pages/AbandonedCartDetails";

// google shopping
import GoogleShopping from "components/GoogleShopping";
import GoogleShoppingSettings from "components/GoogleShopping/pages/Settings";

import Manage from "components/Manage";

import Sliders from "components/Sliders";
import EditSlider from "components/Sliders/pages/Edit";
import CreateSlider from "components/Sliders/pages/Create";

import Testimonials from "components/Testimonials";
import EditTestimonial from "components/Testimonials/pages/Edit";
import CreateTestimonial from "components/Testimonials/pages/Create";

// page not found
import PageNotFound from "components/PageNotFound";

// protected routes
import ProtectedRoute from "./ProtectedRoute";

// scroll to top
import ScrollToTop from "./ScrollToTop";
import CreatePurchaseOrder from "components/PurchaseOrders/Pages/CreatePurchaseOrder";
import ProductFilter from "components/ProductFilters/Pages/ProductFilter";
import AddFilterCriteria from "components/ProductFilters/Pages/AddFilterCriteria";
import SortProductFilters from "components/ProductFilters/Pages/SortProductFilters";
import Payments from "components/Payments";
import StripConnect from "components/Payments/Pages/Stripe/StripConnect";
import AddProductType from "components/ProductFilters/Pages/ProductType/Pages/AddProductType";
import ProductType from "components/ProductFilters/Pages/ProductType";
import EditProductType from "components/ProductFilters/Pages/ProductType/Pages/EditProductType";
import AddDelivery from "components/Shipping/Pages/Shippings/Includes/LocalDelivery/AddDelivery";
import AddSelfPickUp from "components/Shipping/Pages/Shippings/Includes/Pickup/AddSelfPickUp";
import AddShipping from "components/Shipping/Pages/Shippings/Includes/Shipping/AddShipping";
import Shipping from "components/Shipping";
import SortDelivery from "components/Shipping/Pages/SortDelivery";
import EditDeliveryMethod from "components/Shipping/Pages/EditDeliveryMethod";
import DestinationZones from "components/Shipping/Pages/DestinationZones";

// notifications
import Notifications from "components/Notifications";

export default function AllRoutes(props) {
    return (
        <React.Fragment>
            {/* SCROLL TO TOP WHEN ROUTE CHANGES */}
            <ScrollToTop />

            <Switch>
                {/* <ProtectedRoute
                authLoading={props.authLoading}
                path="/"
                component={Dashboard}
                exact /> */}
                <Route path="/" component={Login} exact />
                {/* AUTH */}
                <Route path="/login" component={Login} />
                <Route path="/forgot-password" component={ForgotPassword} />

                <Route
                    path="/reset/password/:userId/:userToken"
                    component={ResetPassword}
                />

                {/* DASHBOARD */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/dashboard"
                    component={Dashboard}
                />
                {/* USERS */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/users"
                    component={Users}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/users/create"
                    component={CreateUser}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/users/edit/:id"
                    component={EditUser}
                    exact
                />
                {/* EMAILS */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/emails/"
                    component={Emails}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/emails/create"
                    component={CreateEmail}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/emails/edit/:id"
                    component={EditEmail}
                    exact
                />
                {/* categories */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/categories/"
                    component={Categories}
                    exact
                />

                {/* brands */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/brands/"
                    component={Brands}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/brands/create"
                    component={CreateBrand}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/brands/edit/:id"
                    component={EditBrand}
                    exact
                />
                {/* products */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/products/"
                    component={Products}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/products/create"
                    component={CreateProduct}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/products/edit/:id"
                    component={EditProduct}
                    exact
                />
                {/* coupons */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/coupons/"
                    component={Coupons}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/coupons/create"
                    component={CreateCoupon}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/coupons/edit/:id"
                    component={EditCoupon}
                    exact
                />

                {/* {Multipliers} */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/multipliers/"
                    component={Multipliers}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/multipliers/brand"
                    component={BrandMultiplier}
                    exact
                />

                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/multipliers/category"
                    component={CategoryMultiplier}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/multipliers/store"
                    component={StoreMultiplier}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/multipliers/product"
                    component={ProductMultiplier}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/multipliers/shipping"
                    component={ShippingMultiplier}
                    exact
                />

                {/* sliders */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/sliders"
                    component={Sliders}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/sliders/create"
                    component={CreateSlider}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/sliders/edit/:sliderId"
                    component={EditSlider}
                    exact
                />

                {/* testimonials */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/testimonials"
                    component={Testimonials}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/testimonials/create"
                    component={CreateTestimonial}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/testimonials/edit/:testimonialId"
                    component={EditTestimonial}
                    exact
                />

                {/* BLOGS */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/blogs/"
                    component={Blogs}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/blogs/create"
                    component={CreateBlog}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/blogs/edit/:id"
                    component={EditBlog}
                    exact
                />

                {/* CUSTOMERS */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/my-sales/customers/"
                    component={Customers}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/my-sales/customers/create"
                    component={CreateCustomer}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/my-sales/customers/edit/:id"
                    component={EditCustomer}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/my-sales/abandoned-carts"
                    component={AbandonedCart}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/my-sales/abandoned-carts/details/:id"
                    component={AbandonedCartDetails}
                    exact
                />

                {/* google shopping */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/my-sales/google-shopping"
                    component={GoogleShopping}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/my-sales/google-shopping/settings"
                    component={GoogleShoppingSettings}
                    exact
                />

                {/* CUSTOMER GROUPS */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/customers/groups"
                    component={CustomerGroups}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/customers/group/create"
                    component={CreateCustomerGroup}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/customers/group/edit/:id"
                    component={EditCustomerGroup}
                    exact
                />
                {/* vendors */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/vendors/"
                    component={Vendors}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/vendors/create"
                    component={CreateVendor}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/catalog/vendors/edit/:id"
                    component={EditVendor}
                    exact
                />
                {/* Sale Orders */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/my-sales/sale-orders/"
                    component={SaleOrders}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/my-sales/sale-orders/create/:id"
                    component={CreateSaleOrder}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/my-sales/sale-orders/create"
                    component={CreateSaleOrder}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/my-sales/sale-orders/edit/:id"
                    component={EditSaleOrder}
                    exact
                />

                {/* purchase Orders */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/catalog/purchase-orders/"
                    component={PurchaseOrders}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/catalog/purchase-orders/create"
                    component={CreatePurchaseOrder}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/catalog/purchase-orders/edit/:id"
                    component={EditPurchaseOrder}
                    exact
                />

                {/* Integration */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/integration"
                    component={Integration}
                    exact
                />

                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/integration/quickbooks"
                    component={Quickbooks}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/integration/quickbooks/connect"
                    component={QuickbooksConnect}
                    exact
                />

                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/integration/quickbooks/settings"
                    component={QuickBooksSetting}
                    exact
                />

                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/integration/mailchimp"
                    component={MailChimp}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/integration/mailchimp/connect"
                    component={MailChimpConnect}
                    exact
                />

                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/integration/mailchimp/settings"
                    component={MailchimpSetting}
                    exact
                />

                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/integration/:title"
                    component={IntegrationDetails}
                    exact
                />

                {/* Manage */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/manage"
                    component={Manage}
                    exact
                />

                {/* Product-Filter */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/product-filters"
                    component={ProductFilter}
                    exact
                />

                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/product-filters/add"
                    component={AddFilterCriteria}
                    exact
                />

                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/product-types"
                    component={ProductType}
                    exact
                />

                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/product-types/add"
                    component={AddProductType}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/product-types/edit/:id"
                    component={EditProductType}
                    exact
                />

                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/product-filters/sort-product-filters"
                    component={SortProductFilters}
                    exact
                />

                {/* Payment */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/payment"
                    component={Payments}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/payment/stripe/connect"
                    component={StripConnect}
                    exact
                />
                {/* Shipping */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/shippings"
                    component={Shipping}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/shippings/shipping-method"
                    component={AddShipping}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/shippings/local-delivery"
                    component={AddDelivery}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/shippings/self-pickup"
                    component={AddSelfPickUp}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/shippings/sort-delivery"
                    component={SortDelivery}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/shippings/edit-delivery-method/:id"
                    component={EditDeliveryMethod}
                    exact
                />
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/shippings/destination-zones"
                    component={DestinationZones}
                    exact
                />

                {/* notifications */}
                <ProtectedRoute
                    authLoading={props.authLoading}
                    path="/store/:storeId/settings/notifications"
                    component={Notifications}
                    exact
                />

                <Route path="**" component={PageNotFound} />
            </Switch>
        </React.Fragment>
    );
}
